import { createSimpleWrapper } from "../tag/createSimpleWrapper";
export const CardText = createSimpleWrapper("p", "card-text");
